import { Button, Input } from '@grofers/react';
import React, { useEffect, useState } from 'react';
import { Textarea, Heading } from '../../../UiKit';
import { useUpdateInvoice } from '../apis';
import { Star } from '../../../UiKit/Star/Star';
import Spinner from 'sushiweb/Spinner/Spinner';
import grey from 'sushiweb/tokens/color/grey';

function UpdateInvoice() {
  const [serialNumbers, setSerialNumbers] = useState();
  const [orderId, setOrderId] = useState();
  const [upc, setUpc] = useState();

  const { mutate, isLoading, isSuccess } = useUpdateInvoice();
  useEffect(() => {
    if (isSuccess) {
      setSerialNumbers([]);
      setOrderId('');
      setUpc('');
    }
  }, [isSuccess]);

  const handleSubmit = (e) => {
    e.preventDefault();
    let serialNums = serialNumbers.split(',');
    let dataToSubmit = {
      order_id: orderId,
      upc: upc,
      serial_numbers: serialNums,
    };

    mutate(dataToSubmit);
  };

  return (
    <div className='tw-w-full tw-bg-base-white tw-rounded-2xl tw-p-6 tw-h-max tw-flex tw-flex-col tw-gap-7'>
      <div>
        <label
          htmlFor='customerIdInput'
          className='tw-w-full tw-flex tw-flex-col tw-gap-1'
        >
          <div>
            <Heading
              title='Serial Numbers'
              color='#1F1F1F'
              weight='600'
              size='17px'
            />
            <Star icon='*' />
          </div>
          <Textarea
            maxLimit={2000}
            showMaxLimit={true}
            showBtn={false}
            placeholder='Please enter comma separated serial numbers'
            className='tw-p-5 focus:tw-border-green-500 focus:tw-ring-2 focus:tw-ring-green-500 focus:tw-outline-none'
            height='12rem'
            required
            value={serialNumbers}
            onChange={(e) => {
              setSerialNumbers(e.target.value);
            }}
            style={{
              outline: '0.5px solid rgb(207, 207, 207)',
              borderRadius: '8px',
              minHeight: '12rem',
            }}
          />
        </label>
      </div>
      <div className='tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-10'>
        <GetIntInputField
          fieldMeta={{
            title: 'Order ID',
            placeholder: 'Enter Order ID',
            onChangeHandler: (e) => {
              setOrderId(e.target.value);
            },
            value: orderId,
          }}
        />
        <GetIntInputField
          fieldMeta={{
            title: 'UPC',
            placeholder: 'Enter UPC',
            onChangeHandler: (e) => {
              setUpc(e.target.value);
            },
            value: upc,
          }}
        />
      </div>
      <div className='tw-mt-8'>
        <Button
          onClick={handleSubmit}
          size='medium'
          variant='fill'
          style={{ padding: '1rem 1.7rem' }}
          disabled={!serialNumbers?.length || !upc || !orderId}
        >
          {isLoading ? (
            <Spinner size='small' color={`${grey.z300}`} />
          ) : (
            'Submit'
          )}
        </Button>
      </div>
    </div>
  );
}

const GetIntInputField = ({ fieldMeta }) => {
  const { title, placeholder, onChangeHandler, value } = fieldMeta;
  return (
    <label
      htmlFor='customerIdInput'
      className='tw-w-full tw-flex tw-flex-col tw-gap-1'
    >
      <div>
        <Heading title={title} color='#1F1F1F' weight='600' size='17px' />
        <Star icon='*' />
      </div>
      <Input
        placeholder={placeholder}
        style={{
          padding: '1.22rem 1rem',
          fontWeight: '400',
          fontSize: '1.33rem',
        }}
        onChange={onChangeHandler}
        value={value}
      />
    </label>
  );
};

export default UpdateInvoice;
